<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();
auth.getCurrentSession();
</script>

<template>
  <component
    :is="auth.rootComponent"
    :key="auth.session?.id ?? '-'"
    @logout="auth.logout"
  />
</template>
